/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import VueScrollTo from 'vue-scrollto';
import Router from 'vue-router';

// SESSIONS
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import { SCORM } from 'pipwerks-scorm-api-wrapper';
import router from './router';

Vue.use(Vuex);
Vue.use(VueScrollTo);

export default new Vuex.Store({
  state: {
    /**
     * Current Location of Course
     */
    currentLocation: 0,

    // IF SCORM is enabled use SCORM 1.2 calls, otherwise use cookies
    scormEnabled: false,

    /**
     * MENU ITEMS
     * -----------
     * activeLink = url of section
     * activeLocation = number of currentLocation that "activates" the menu
     */
    menuItems: [
      // {
      //   title: 'Introduction',
      //   imgSrc: 'rca-rs-menu1.jpg',
      //   currentIcon: 'menu-status_incomplete.png',
      //   sideMenuIcon: 'menu-status_active.png',
      //   enabled: false,
      //   activeLink: '/',
      //   currentLink: '',
      //   activeLocation: 0,
      // },
      {
        title: 'Évaluation des risques',
        imgSrc: 'rca-rs-menu2.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-02',
        currentLink: '',
        activeLocation: 2,
        completedLocation: 7,
      },
      {
        title: 'La sécurité nautique',
        imgSrc: 'rca-rs-menu3.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-03',
        currentLink: '',
        activeLocation: 7,
        completedLocation: 18,
      },
      {
        title: 'Environnement et conditions climatiques',
        imgSrc: 'rca-rs-menu4.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-04',
        currentLink: '',
        activeLocation: 18,
        completedLocation: 26,
      },
      {
        title: 'Interventions en cas d\'urgence pour l\'athlète',
        imgSrc: 'rca-rs-menu5.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-05',
        currentLink: '',
        activeLocation: 26,
        completedLocation: 36,
      },
      {
        title: 'Sécurité individuelle',
        imgSrc: 'rca-rs-menu6.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-06',
        currentLink: '',
        activeLocation: 36,
        completedLocation: 43,
      },
      {
        title: 'Équipement',
        imgSrc: 'rca-rs-menu7.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-07',
        currentLink: '',
        activeLocation: 43,
        completedLocation: 52,
      },
      {
        title: 'Pour la suite',
        imgSrc: 'rca-rs-menu8.jpg',
        currentIcon: 'menu-status_incomplete.png',
        sideMenuIcon: 'menu-status_active.png',
        enabled: false,
        activeLink: '/module-08',
        currentLink: '',
        activeLocation: 52,
        completedLocation: 54,
      },
    ],
  },
  mutations: {
    /**
     * Update current location if the clicked button is higher than the current page count
     */
    showNext(state, n) {
      if (n >= state.currentLocation) {
        state.currentLocation = n;
      }
    },

    /**
     * Update current location if the clicked button is higher than the current page count
     */
    changeMenuStatus(state) {
      for (let i = 0; i < state.menuItems.length; i++) {
        const el = state.menuItems[i];
        if (state.currentLocation === el.activeLocation) {
          el.currentIcon = 'menu-status_active.png';
          el.sideMenuIcon = 'menu-status_active.png';
        } else if ( state.currentLocation >= el.completedLocation ) {
          el.currentIcon = 'menu-status_complete.png';
          el.sideMenuIcon = 'menu-status_complete.png';
        }
      }
    },
  },
  actions: {
    showNext(context, obj) {
      context.commit('showNext', obj.n);
      context.commit('changeMenuStatus');

      setTimeout(() => {
        VueScrollTo.scrollTo(obj.el, { offset: -60 });
        console.log(obj.el);
      }, 100);

      // Set SCORM Completion
      // we should probably set a totalPages variable
      if (this.state.scormEnabled) {
        SCORM.set('cmi.core.lesson_location', obj.n);
        SCORM.save();
      } else {
        // Cookies set current location
        Vue.$cookies.set('currentLocation-FR', obj.n)
      }
      

      if (obj.n >= 54) {
        console.log('Course Complete')
        if (this.state.scormEnabled) { 
          SCORM.set('cmi.core.lesson_status', 'completed');
          SCORM.save();
        } else {
          // Cookies set Completed
        }
        
      }
    },
    initCourse (context) {
      /**
       * Insert SCORM hooks
       */
       context.commit('changeMenuStatus');
       let currentLocation
 
       if (this.state.scormEnabled) {
         SCORM.version = '1.2'
         let success = SCORM.init()
         if (success) {
           if (SCORM.get("cmi.core.lesson_location") != null || SCORM.get("cmi.core.lesson_location") != '' || SCORM.get("cmi.core.lesson_location") == undefined) {
             this.state.currentLocation = SCORM.get("cmi.core.lesson_location")
           }
         }
       } else {
         // GET Cookies location
         console.log(Vue.$cookies.get('currentLocation-FR'))
         // this.$session.start()
         if (Vue.$cookies.get('currentLocation-FR') != null) {
           this.state.currentLocation = Vue.$cookies.get('currentLocation-FR')
         }
       }
       currentLocation = this.state.currentLocation
      // switch (true) {
      //   case (currentLocation >= 44):
      //     router.push('/wrap-up')
      //     break;

      //   case (currentLocation >= 33):
      //     router.push('/using-an-eap')
      //     break;

      //   case (currentLocation >= 13):
      //     router.push('/identifying-managing-safety-risks')
      //     break;

      //   case (currentLocation >= 1):
      //     router.push('/coaching-rca-adp')
      //     break;
      
      //   default:
      //     router.push('/')
      //     break;
      // }
    }
  },
});
